<template>
    <div :class="[excludeFromPrintClassName]">
        <button @click="downloadFile">Download PDF</button>
    </div>
</template>

<script>
import getMediaUrl from '@/helpers/getMediaUrl';

export default {
    props: {
        value: {
            type: Object,
            required: true
        },

        excludeFromPrintClassName: {
            type: String,
            required: true
        }
    },

    methods: {
        downloadFile() {
            const url = getMediaUrl(this.value);

            this.$downloadFile(
                url,
                this.value.name,
                ['video', 'pdf', 'audio'].includes(this.value.type)
            );
        }
    }
};
</script>
